export const orderTypes = {
  INSTRUMENT: 'ISSUE',
  ENTITY: 'ISSUER',
  SIG_ENTITY: 'SIG_ISSUER',
};
